import { adnFetch } from "./fetch";

const adnUser = async (username: string, access_token?: string) => {
    const user = await adnFetch(`/v1/user`, { token: access_token });
    const teams = await adnFetch(`/v1/teams`, { token: access_token });
    user["teams"] = teams.results;
    return user;
};
export default adnUser;
